import React, { PropTypes } from "react";
import moment from "moment";
import Avatar from "components/Avatar/Avatar";
import { CPDPoints } from "components/CPDPoints";
import renderSponsors from "components/Dashboard/renderSponsors";
import renderPartners from "components/Dashboard/renderPartners";
import renderExperts from "components/Dashboard/renderExperts";
import renderSponsorCheckbox from "components/Dashboard/renderSponsorCheckbox";
import { FormControl, FormControlLabel } from "material-ui/Form";
import Radio, { RadioGroup } from "material-ui/Radio";
import Checkbox from "material-ui/Checkbox";
import axios from "axios";
import constants from "constants";
import { Link } from "react-router";

const { CPD_STATUSES } = constants;

const cpdStatus = {
  [CPD_STATUSES.granted]: "CPD Granted",
  [CPD_STATUSES.applied_for]: "CPD Applied for",
  [CPD_STATUSES.not_applicable]: "CPD Not applicable",
};

class UpcomingWebinarLandingItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { webinar } = this.props;
    const {
      webinar_title,
      start_date,
      end_date,
      cpd_status,
      sponsor,
      sponsors,
      partnerships,
      subscription_id,
      experts,
      sessions,
      galery_images,
      id,
    } = webinar;

    return (
      <div className="landingWebinarItem" id={`LWI_${id}`}>
        <div className="LWI_img">
          <img
            src={galery_images.length && galery_images[0].image_url}
            alt=""
          />
          <div className="LWI_CPD">
            <p>{cpdStatus[cpd_status]}</p>
          </div>
        </div>
        <div className="LWI_title">{webinar_title}</div>
        <div className="LWI_info">
          <div>
            <div className="info" style={{ marginBottom: 0 }}>
              <div
                style={{
                  display: "flex",
                  gap: "5px",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <i className="material-icons icon_search">event</i>
                <p>
                  <span>{moment(start_date).format("dddd")} </span>
                  <span>{moment(start_date).format("D MMMM")} </span>
                </p>
              </div>
              <div
                style={{
                  display: "flex",
                  gap: "5px",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <i className="material-icons icon_search">schedule</i>
                <p>
                  {moment(start_date).format("h:mma")}
                  {" - "}
                  {moment(end_date).format("h:mma")}
                </p>
              </div>
            </div>
            <div>
              <Link to="/users/sign_in" className="button_classic">
                Register Interest
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

UpcomingWebinarLandingItem.propTypes = {
  webinar: PropTypes.obj,
  toggleSubscription: PropTypes.obj,
  userRole: PropTypes.string,
};

export default UpcomingWebinarLandingItem;



// WEBPACK FOOTER //
// ./src/components/Dashboard/UpcomingWebinars/UpcomingWebinarLandingItem.js